import { InjectionToken } from '@angular/core';

export const ADDAPPTABLE_MODAL_CONFIG = new InjectionToken<string>('ADDAPPTABLE_MODAL_CONFIG');
